
const WalletIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M39.336 8.216a1 1 0 0 0-1.41.16L28.72 20h-5.103L34.791 5.892a5 5 0 0 1 7.046-.798l10.292 8.244A5.001 5.001 0 0 1 53.174 20h-5.228l1.815-2.107a1 1 0 0 0-.133-1.433l-5.008-4.012L38.684 20h-5.087l7.9-10.053-2.161-1.731ZM12 14a6 6 0 0 0-6 6v29a9 9 0 0 0 9 9h34a9 9 0 0 0 9-9V31a9 9 0 0 0-9-9H12a2 2 0 1 1 0-4h9.16l3.192-4H12Zm30 24h6a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4Z"
    />
  </svg>
)
export default WalletIcon
